// extracted by mini-css-extract-plugin
module.exports = {"Support":"Support_Support__MBC2C","SupportContainer":"Support_SupportContainer__jxT4W"};